import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    evento: '',

    codigosPromocion: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR_CODIGOS' (state, eventoId) {
        state.eventoId = eventoId;
        state.evento = '';
    
        state.codigoPromocion = [];
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
    },
    'SET_EVENTO' (state, evento) {
        // state.evento = evento;
        state.evento = evento.nombre;
    },
    'SET_CODIGOS' (state, codigosPromocion) {
        state.codigosPromocion = codigosPromocion;
        state.paginaActual = 1;
        state.totalRegistros = codigosPromocion.length;
    },
};

const getters = {
    getField,
};

const actions = {
    getCodigosPromocion ( { commit }, eventoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CODIGOS', eventoId);

            apiAxios.get('eventos/' + state.eventoId) 
            .then(res => {
                commit('SET_EVENTO', res.data);
                return apiAxios.get('eventos/' + state.eventoId + '/codigos-promocion')
            })
            .then(res => {
                commit('SET_CODIGOS', res.data);
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    importarCodigosPromocion ( {}, params ) {
        return new Promise((resolve, reject) => {
            let error;
            let fileName = params.file.name;
            let fileExtension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase();
            let fileSize = parseFloat(params.file.size / 1048576);

            if (fileExtension != 'csv') {
                    error = 'El tipo de archivo seleccionado no es válido. Sólo se permiten archivos de tipo csv.';
            }

            // if (fileSize >= 1 ) {
            //     error = 'El archivo seleccionado tiene un peso mayor al permitido. Sólo se permiten imágenes de hasta 1MB.';
            // }

            if (error) {
                reject(error);
            } else {
				let formData = new FormData();
                formData.append('file', params.file);

                let options = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }				

				apiAxios.post('eventos/' + params.eventoId + '/codigos-promocion', formData, options)
                    .then(() => resolve())
					.catch(error => reject(helpers.methods.getErrorMessage(error)));
			}
        })
    },	

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}